import styled from "styled-components";

export const Container = styled.section`
    margin-top: 10rem;
    padding: 0 4rem;

    h2 {
        text-align: center;
        font-size: 4.5rem;
        margin-bottom: 4rem;
        color: var(--blue);
    }

    .projects {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
        gap: 3rem;
        padding: 3rem 0;
    }

    .project {
        position: relative;
        background: #2b2b2b;
        color: #fff;
        font-family: "Source Sans Pro", sans-serif;
        padding: 3rem;
        border-radius: 15px;
        box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        overflow: hidden;
        z-index: 1;
        height: 100%;

        &:hover {
            transform: translateY(-10px);
            box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.4);
            z-index: 5;
        }

        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 2rem;

            .project-links {
                display: flex;
                align-items: center;
                gap: 1.5rem;

                a > img {
                    width: 3rem;
                    transition: transform 0.3s ease;
                }

                a:hover img {
                    transform: scale(1.2);
                }

                svg {
                    width: 60px;
                    height: 60px;
                    stroke-width: 1.5;
                }
            }
        }

        /* Hide Description and Tech List by Default */
        p,
        .tech-list {
            opacity: 0;
            transform: translateY(15px);
            transition: opacity 0.3s ease, transform 0.3s ease;
        }

        /* Show on Hover */
        &:hover p,
        &:hover .tech-list {
            opacity: 1;
            transform: translateY(0);
        }

        /* Inline List with Bullet Points */
        .tech-list {
            display: flex;
            flex-wrap: wrap;
            gap: 1.5rem;
            font-size: 1.6rem;
            list-style: none;
            padding: 0;
        }

        .tech-list li::before {
            content: "•";
            margin-right: 0.5rem;
            color: var(--blue);
            font-size: 2rem;
        }

        /* Hover Effect Stays Inside the Block */
        &::before,
        &::after {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: var(--blue);
            opacity: 0.5;
            transition: transform 0.45s ease;
            z-index: -1;
        }

        &::before {
            transform: skew(30deg) translateX(-80%);
        }

        &::after {
            transform: skew(-30deg) translateX(-70%);
        }

        &:hover::before {
            transform: skew(30deg) translateX(-30%);
        }

        &:hover::after {
            transform: skew(-30deg) translateX(-20%);
        }

        h3 {
            font-size: 2.4rem;
            // margin-bottom: 1.5rem;
        }

        p {
            font-size: 1.6rem;
            line-height: 1.8;
        }

        footer {
            margin-top: auto;
        }
    }

    @media (max-width: 1024px) {
        .projects {
            grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        }

        h2 {
            font-size: 4rem;
        }
    }

    @media (max-width: 768px) {
        .projects {
            grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
        }

        .project {
            padding: 2.5rem;
        }

        h2 {
            font-size: 3.5rem;
        }
    }

    @media (max-width: 480px) {
        h2 {
            font-size: 3rem;
        }

        .project {
            padding: 2rem;
        }
    }
`;
